// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"520":"7f48edce","948":"17e32879"}[chunkId] + ".chunk.js";
};